<template>
  <div class="container">
    <div class="page__breadcrumbs">
      <div
        class="breadcrumbs"
        itemscope
        itemtype="https://schema.org/BreadcrumbList"
      >
        <span
          class="breadcrumbs__item"
          itemprop="itemListElement"
          itemscope
          itemtype="https://schema.org/ListItem"
        >
          <a href="/" itemprop="item"
            ><span itemprop="name">Главная&#8199;</span></a
          >
        </span>
        <span
          v-for="(item, index) in breadcrumbs"
          :key="index"
          class="breadcrumbs__item"
          itemprop="itemListElement"
          itemscope
          itemtype="https://schema.org/ListItem"
        >
          <span v-if="item.href == ''" itemprop="name">{{ item.name }}</span>

          <router-link v-else :to="item.href.fullPath || item.href">
            <span itemprop="name">{{ item.name }}</span>
          </router-link>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Breadcrumbs",
  computed: {
    breadcrumbs() {
      return this.$store.getters["bread_crumbs/GET_CRUMBS"];
    },
  },

  watch: {
    // $route(to, from) {
    // console.log(from)
    // console.log(to)
    // console.log(this.$route)
    // }
  },
};
</script>
